export default __webpack_public_path__ + "static/media/bg_main_news.def21a00.png";